import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectCurrentTrip } from '../../actions';
import Itinerary from './Itinerary';

class DirectionsListAll extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick.bind(this);
    }
   

    handleClick(idx) {
        this.props.selectCurrentTrip(idx);
    }


    render() {        
    
        return(
            <div className="otp-accordion">
                {this.props.trips.map((trip, idx) => {
                    const tripKey = trip.duration.toString() + trip.startTime.toString() + trip.walkTime.toString();
                    const sectionNumber = (idx + 1).toString();
                    return (
                        <Itinerary
                            trip={trip}
                            key={tripKey}
                            label={sectionNumber}
                            isOpen={idx === this.props.currentTrip}
                            handleClick={() => this.handleClick(idx)}
                        />

                    );
                })}
            </div>
        );
    }
}

const mapDispatch = dispatch => {
    return bindActionCreators({selectCurrentTrip}, dispatch);
};

export default connect(null, mapDispatch)(DirectionsListAll);